import React, { useState } from "react";
import { Form } from "react-bootstrap";
import _ from "lodash";
import { connect } from "react-redux";
import { getFullName } from "../../../Modules/utils/fullname";
import DateRangeFilter from "../../Components/DateRangeFilter";

const DynamicFilters = ({
  type,
  values = {},
  onChange,
  agents,
  offices,
  isHeadOffice = false,
}) => {
  const [filterType, setFilterType] = useState("today");

  if (!onChange) return null;

  const update = (key, val) => {
    onChange({ [key]: val });
  };

  const headOfficeFilters = [{ key: "office", label: "Office", type: "text" }];
  const extraFilters = isHeadOffice ? headOfficeFilters : [];

  const FILTERS_BY_TYPE = {
    all: [
      { key: "relatedUser", label: "Field Executive", type: "text" },
      ...extraFilters,
    ],
    agent_report: [
      { key: "relatedUser", label: "Field Executive", type: "text" },
      ...extraFilters,
    ],
    user_payin: [
      { key: "relatedUser", label: "Field Executive", type: "text" },
      { key: "rtoLossList.id", label: "RTO Lost ID", type: "text" },
      ...extraFilters,
    ],
    user_payout: [
      { key: "relatedUser", label: "Field Executive", type: "text" },
      ...extraFilters,
    ],
    office_expense: [
      { key: "transactionItem", label: "Item", type: "text" },
      ...extraFilters,
    ],
    owner_collection: [...extraFilters],
  };

  const filters = FILTERS_BY_TYPE[type] || FILTERS_BY_TYPE.all;

  const handleClear = () => {
    const cleared = {};
    for (const f of filters) cleared[f.clearKey || f.key] = undefined;
    onChange(cleared);
  };

  const dynamicFilters = (
    <div className="d-flex flex-wrap gap-1">
      {filters.map((f) => (
        <div
          key={f.key}
          className="d-flex flex-column"
          style={{ minWidth: 140 }}
        >
          <Form.Label
            className="mb-0 text-muted small fw-semibold"
            style={{ fontSize: "0.75rem" }}
          >
            {f.label}
          </Form.Label>
          {f.key === "relatedUser" ? (
            <Form.Control
              as="select"
              value={values[f.key] || ""}
              onChange={(e) => update(f.key, e.target.value || undefined)}
            >
              <option value="">All</option>

              {agents?.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {getFullName(agent)}
                </option>
              ))}
            </Form.Control>
          ) : f.key === "office" ? (
            <Form.Control
              as="select"
              value={values[f.key] || ""}
              onChange={(e) => update(f.key, e.target.value || undefined)}
            >
              <option value="">All</option>

              {offices?.map((office) => (
                <option key={office._id} value={office._id}>
                  {getFullName(office)}
                </option>
              ))}
            </Form.Control>
          ) : (
            <Form.Control
              type={f.type}
              value={
                f.getValue ? f.getValue(values) || "" : values[f.key] || ""
              }
              placeholder={f.label}
              onChange={(e) =>
                f.setValue
                  ? f.setValue(e.target.value || undefined, values, onChange)
                  : update(f.key, e.target.value || undefined)
              }
              size="sm"
              style={{
                minHeight: "32px",
                fontSize: "0.8rem",
              }}
            />
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div
      className="p-2 border rounded d-flex flex-wrap justify-content-between mb-2 pb-0 bg-light"
      style={{ rowGap: "0.5rem" }}
    >
      <div>{dynamicFilters}</div>
      <div>
        <div className="text-nowrap " style={{ maxWidth: "400px" }}>
          <div
            style={{
              fontSize: "11px",
              color: "gray",
              textAlign: "center",
            }}
          >
            Date Range Filter
          </div>
          {/* ===== Header (Mobile Friendly) ===== */}

          <DateRangeFilter
            filterType={filterType}
            startDate={values?.date?.$gte}
            endDate={values?.date?.$lt}
            maxDateCount={0}
            onChange={({ filterType, start, end }) => {
              setFilterType(filterType);

              onChange({
                date: {
                  $gte: start,
                  $lt: end,
                },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DynamicFilters);
